import axios, { type AxiosRequestConfig } from 'axios';

export default async (nonAgentId: string) => {
  const config: AxiosRequestConfig = {
    url: `/nonagent/delete/${nonAgentId}`,
    method: 'post',
  };

  await axios.request(config);
};
